import EmailCampaignToken from '@apps/campaigns/admin/tokens/campaign/email'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Send extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    modal: PropTypes.object
  }

  static propTypes = {
    contact: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { contact } = this.props
    return {
      title: 't(Send Email Campaign)',
      method: 'POST',
      action: `/api/admin/crm/contacts/${contact.id}/emails/send`,
      saveText: 't(Send)',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            {
              label: 't(Email Campaign)',
              name: 'email_campaign_id',
              type: 'radiogroup',
              endpoint: '/api/admin/campaigns/email',
              valueKey: 'id',
              textKey: 'title'
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(result) {
    this.context.modal.close()
  }

}

export default Send
